import { render, staticRenderFns } from "./assign-studies-modal.vue?vue&type=template&id=8e8f4918&"
import script from "./assign-studies-modal.vue?vue&type=script&lang=js&"
export * from "./assign-studies-modal.vue?vue&type=script&lang=js&"
import style0 from "./assign-studies-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "assign-studies-modal.vue"
export default component.exports